export const byStepId = (a: { step_id?: number }, b: { step_id?: number }) => (a.step_id ?? 0) - (b.step_id ?? 0);
